import { titleize } from '@helpers/StringHelper'

export default titleize
